export default __webpack_public_path__ + "media/images/signup/work-48003afa85653e2c59f7435844bb7d15.png";